const menuBtn = document.getElementById("menu-btn");
const navLinks = document.getElementById("nav-list");
const menuBtnIcon = menuBtn.querySelector("i");

menuBtn.addEventListener("click", (e) => {
  navLinks.classList.toggle("open");

  const isOpen = navLinks.classList.contains("open");
  menuBtnIcon.setAttribute("class", isOpen ? "ri-close-line" : "ri-menu-line");
});

navLinks.addEventListener("click", (e) => {
  navLinks.classList.remove("open");
  menuBtnIcon.setAttribute("class", "ri-menu-line");
});

const sr = ScrollReveal({
  distance: "50px",
  origin: "bottom",
  duration: 1000,
});

sr.reveal(".header__container h1");
sr.reveal(".header__container p", { delay: 500 });
sr.reveal(".header__container form", { delay: 1000 });
sr.reveal(".header__container a", { delay: 1500 });

const swiper = new Swiper(".swiper", {
  loop: true,
  pagination: {
    el: ".swiper-pagination",
  },
});